/**
 * Free-trial configuration — fallback constant + shape.
 *
 * The trial is per-user and always offered: every new account gets a free trial
 * of `trialDays` length, frozen at registration. This module exposes only the
 * LENGTH (for generic pricing copy). A logged-in user's actual expiry date comes
 * from GET /v2/me (`subscription.trialEndsAt`), surfaced via useUserInfo().
 *
 * Live length is read via the usePromoConfig() hook (pulls GET /v2/pricing/promo);
 * FALLBACK_PROMO_CONFIG below is used on first paint and on API failure. Keep the
 * fallback length in sync with the API's TRIAL_PERIOD_DAYS.
 */

export interface PromoConfig {
  /** Free trial length in days, e.g. 60. */
  trialDays: number;
  /** Short label for inline copy, e.g. "60-day". */
  trialLabel: string;
}

/** Derive the PromoConfig shape from a trial length in days. */
export function buildPromoConfig(trialDays: number): PromoConfig {
  return { trialDays, trialLabel: `${trialDays}-day` };
}

/**
 * Fallback config used before the API responds, or when /v2/pricing/promo is
 * unreachable. Keep in sync with the API's TRIAL_PERIOD_DAYS.
 */
export const FALLBACK_PROMO_CONFIG: PromoConfig = buildPromoConfig(60);
